var _defs, _rect, _g, _g2, _g3, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShadeRoutes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 135.47 135.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter1926-2",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(9,210,255)",
    result: "flood1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "SourceGraphic",
    operator: "in",
    result: "fbSourceGraphic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(9,210,255)",
    result: "flood1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    operator: "in",
    result: "fbSourceGraphic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k1: 0.4,
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(9,124,255)",
    result: "flood1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    operator: "in",
    result: "fbSourceGraphic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "fbSourceGraphic",
    result: "fbSourceGraphicAlpha",
    values: "0 0 0 -1 0 0 0 0 -1 0 0 0 0 -1 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "fbSourceGraphic",
    in2: "fbSourceGraphic",
    k1: 0.4,
    k2: 1,
    operator: "arithmetic",
    result: "composite1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "composite1",
    result: "colormatrix1",
    type: "saturate",
    values: 1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "rgb(9,124,255)",
    result: "flood1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "flood1",
    in2: "colormatrix1",
    mode: "multiply",
    result: "blend1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "blend1",
    mode: "screen",
    result: "blend2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blend2",
    result: "colormatrix2",
    type: "saturate",
    values: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "colormatrix2",
    in2: "fbSourceGraphic",
    operator: "in",
    result: "composite2"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(.038735 .039628 -.17852 .18263 115.12 51.83)",
    x: 95.807,
    y: 82.876,
    width: 99.209,
    height: 209.56,
    fill: "#72b1fe",
    filter: "url(#filter1926-2)",
    stroke: "#fff",
    strokeOpacity: 0.86735,
    strokeWidth: 3.3213
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.022444 .022813 -.17761 .18053 118.93 57.303)",
    fill: "#fff",
    filter: "url(#filter1627)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.189,
    y: 190.06,
    width: 7.2163,
    height: 19.778
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.189,
    y: 220.42,
    width: 7.2163,
    height: 19.778
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.189,
    y: 250.78,
    width: 7.2163,
    height: 19.778
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.022444 .022813 -.17761 .18053 135.14 40.842)",
    fill: "#fff",
    filter: "url(#filter1627)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.189,
    y: 190.06,
    width: 7.2163,
    height: 19.778
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.189,
    y: 220.42,
    width: 7.2163,
    height: 19.778
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.189,
    y: 250.78,
    width: 7.2163,
    height: 19.778
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.03873 .039633 -.17849 .18265 121.08 55.795)",
    filter: "url(#filter1627)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeDashoffset: 10,
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-193.02 245.9c65.672 14.25 131.34 28.499 197.01 42.749-0.68082-2.5328-1.3616-5.0656-2.0424-7.5984-62.827-13.632-125.65-27.265-188.48-40.897-2.1637 1.9156-4.3274 3.8312-6.4912 5.7468z",
    fill: "#353564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.9936 288.65c10.997 0.0879 21.994 0.17579 32.991 0.26368-1.209-2.6502-2.4179-5.3004-3.6268-7.9505-10.469 0.0295-20.938 0.0589-31.407 0.0884 0.68082 2.5328 1.3616 5.0656 2.0424 7.5984z",
    fill: "#afafde"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-186.53 240.15c7.7507-0.58974 15.517-1.4124 23.258-1.8566 65.543 14.222 131.09 28.444 196.63 42.665-10.563-0.0129-21.144 0.14454-31.696 0.0257-62.731-13.612-125.46-27.223-188.19-40.835z",
    fill: "#e9e9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-193.02 245.9c7.9177-0.58027 15.835-1.1605 23.753-1.7408 1.9023-1.9751 3.8046-3.9502 5.7068-5.9253-7.6563 0.63976-15.313 1.2795-22.969 1.9193-2.1637 1.9156-4.3274 3.8312-6.4912 5.7468z",
    fill: "#4d4d9f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-169.27 244.16c68.751 14.918 137.5 29.836 206.25 44.753-1.209-2.6502-2.4179-5.3004-3.6268-7.9505-65.64-14.243-131.28-28.485-196.92-42.728-1.9023 1.9751-3.8046 3.9502-5.7068 5.9253z",
    fill: "#d7d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-193.02 245.9c8.012-0.53093 16.04-1.2878 24.042-1.6781 68.654 14.897 137.31 29.794 205.96 44.691-11.091-0.12903-22.2-0.09673-33.28-0.32639-65.575-14.229-131.15-28.457-196.73-42.686z",
    fill: "#8686bf"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.03873 .039633 -.17849 .18265 153.91 21.992)",
    filter: "url(#filter1627)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeDashoffset: 10,
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-193.02 245.9c65.672 14.25 131.34 28.499 197.01 42.749-0.68082-2.5328-1.3616-5.0656-2.0424-7.5984-62.827-13.632-125.65-27.265-188.48-40.897-2.1637 1.9156-4.3274 3.8312-6.4912 5.7468z",
    fill: "#353564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.9936 288.65c10.997 0.0879 21.994 0.17579 32.991 0.26368-1.209-2.6502-2.4179-5.3004-3.6268-7.9505-10.469 0.0295-20.938 0.0589-31.407 0.0884 0.68082 2.5328 1.3616 5.0656 2.0424 7.5984z",
    fill: "#afafde"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-186.53 240.15c7.7507-0.58974 15.517-1.4124 23.258-1.8566 65.543 14.222 131.09 28.444 196.63 42.665-10.563-0.0129-21.144 0.14454-31.696 0.0257-62.731-13.612-125.46-27.223-188.19-40.835z",
    fill: "#e9e9ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-193.02 245.9c7.9177-0.58027 15.835-1.1605 23.753-1.7408 1.9023-1.9751 3.8046-3.9502 5.7068-5.9253-7.6563 0.63976-15.313 1.2795-22.969 1.9193-2.1637 1.9156-4.3274 3.8312-6.4912 5.7468z",
    fill: "#4d4d9f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-169.27 244.16c68.751 14.918 137.5 29.836 206.25 44.753-1.209-2.6502-2.4179-5.3004-3.6268-7.9505-65.64-14.243-131.28-28.485-196.92-42.728-1.9023 1.9751-3.8046 3.9502-5.7068 5.9253z",
    fill: "#d7d7ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-193.02 245.9c8.012-0.53093 16.04-1.2878 24.042-1.6781 68.654 14.897 137.31 29.794 205.96 44.691-11.091-0.12903-22.2-0.09673-33.28-0.32639-65.575-14.229-131.15-28.457-196.73-42.686z",
    fill: "#8686bf"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.040061 .041541 -.18463 .19145 76.57 9.2861)",
    filter: "url(#filter1627)"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "matrix(1 .0012842 .027266 .99963 0 0)",
    x: 89.39,
    y: 91.852,
    width: 95.139,
    height: 201.04,
    fill: "#ababab",
    stroke: "#fff",
    strokeOpacity: 0.86735,
    strokeWidth: 3.1856
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.55385 .000321 .011707 .95099 111.32 16.624)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.189,
    y: 190.06,
    width: 7.2163,
    height: 19.778
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.189,
    y: 220.42,
    width: 7.2163,
    height: 19.778
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.189,
    y: 250.78,
    width: 7.2163,
    height: 19.778
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.55385 .000321 .011707 .95099 110.5 -70.143)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 50.189,
    y: 190.06,
    width: 7.2163,
    height: 19.778
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.189,
    y: 220.42,
    width: 7.2163,
    height: 19.778
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.189,
    y: 250.78,
    width: 7.2163,
    height: 19.778
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.95898 .0012566 .026691 .95898 119.51 6.8841)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeDashoffset: 10,
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-193.02 245.9c65.672 14.25 131.34 28.499 197.01 42.749-0.68082-2.5328-1.3616-5.0656-2.0424-7.5984-62.827-13.632-125.65-27.265-188.48-40.897-2.1637 1.9156-4.3274 3.8312-6.4912 5.7468z",
    fill: "#4c4c4c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.9936 288.65c10.997 0.0879 21.994 0.17579 32.991 0.26368-1.209-2.6502-2.4179-5.3004-3.6268-7.9505-10.469 0.0295-20.938 0.0589-31.407 0.0884 0.68082 2.5328 1.3616 5.0656 2.0424 7.5984z",
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-186.53 240.15c7.7507-0.58974 15.517-1.4124 23.258-1.8566 65.543 14.222 131.09 28.444 196.63 42.665-10.563-0.0129-21.144 0.14454-31.696 0.0257-62.731-13.612-125.46-27.223-188.19-40.835z",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-193.02 245.9c7.9177-0.58027 15.835-1.1605 23.753-1.7408 1.9023-1.9751 3.8046-3.9502 5.7068-5.9253-7.6563 0.63976-15.313 1.2795-22.969 1.9193-2.1637 1.9156-4.3274 3.8312-6.4912 5.7468z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-169.27 244.16c68.751 14.918 137.5 29.836 206.25 44.753-1.209-2.6502-2.4179-5.3004-3.6268-7.9505-65.64-14.243-131.28-28.485-196.92-42.728-1.9023 1.9751-3.8046 3.9502-5.7068 5.9253z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-193.02 245.9c8.012-0.53093 16.04-1.2878 24.042-1.6781 68.654 14.897 137.31 29.794 205.96 44.691-11.091-0.12903-22.2-0.09673-33.28-0.32639-65.575-14.229-131.15-28.457-196.73-42.686z",
    fill: "#a2a2a2"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.95898 .0012566 .026691 .95898 111.99 -170.03)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    strokeDashoffset: 10,
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-193.02 245.9c65.672 14.25 131.34 28.499 197.01 42.749-0.68082-2.5328-1.3616-5.0656-2.0424-7.5984-62.827-13.632-125.65-27.265-188.48-40.897-2.1637 1.9156-4.3274 3.8312-6.4912 5.7468z",
    fill: "#4c4c4c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.9936 288.65c10.997 0.0879 21.994 0.17579 32.991 0.26368-1.209-2.6502-2.4179-5.3004-3.6268-7.9505-10.469 0.0295-20.938 0.0589-31.407 0.0884 0.68082 2.5328 1.3616 5.0656 2.0424 7.5984z",
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-186.53 240.15c7.7507-0.58974 15.517-1.4124 23.258-1.8566 65.543 14.222 131.09 28.444 196.63 42.665-10.563-0.0129-21.144 0.14454-31.696 0.0257-62.731-13.612-125.46-27.223-188.19-40.835z",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-193.02 245.9c7.9177-0.58027 15.835-1.1605 23.753-1.7408 1.9023-1.9751 3.8046-3.9502 5.7068-5.9253-7.6563 0.63976-15.313 1.2795-22.969 1.9193-2.1637 1.9156-4.3274 3.8312-6.4912 5.7468z",
    fill: "#767676"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-169.27 244.16c68.751 14.918 137.5 29.836 206.25 44.753-1.209-2.6502-2.4179-5.3004-3.6268-7.9505-65.64-14.243-131.28-28.485-196.92-42.728-1.9023 1.9751-3.8046 3.9502-5.7068 5.9253z",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m-193.02 245.9c8.012-0.53093 16.04-1.2878 24.042-1.6781 68.654 14.897 137.31 29.794 205.96 44.691-11.091-0.12903-22.2-0.09673-33.28-0.32639-65.575-14.229-131.15-28.457-196.73-42.686z",
    fill: "#a2a2a2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadeRoutes);
export default __webpack_public_path__ + "static/media/shade_routes.57c6462682120af7a4c69971208d2088.svg";
export { ForwardRef as ReactComponent };